import axios from 'axios'

import cookieUtility from '../utils/cookie.utility.js'

const AUTH_URL = import.meta.env.VITE_AUTH_URL || ''

async function loginUser(email, password) {
  return axios.post(`${AUTH_URL}/auth/login`, { email, password }, { withCredentials: true })
}

// On `403 { code: "CSRF_REISSUED" }` the DAL has set a fresh csrf_token cookie
// and asks us to retry once — we do, using the new cookie value.
async function logoutUser() {
  let csrfToken = cookieUtility.get(`${import.meta.env.VITE_COOKIE_PREFIX}csrf_token`)

  try {
    return await axios.post(
      `${AUTH_URL}/auth/logout`,
      {},
      {
        withCredentials: true,
        headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : {},
      },
    )
  } catch (error) {
    if (error.response?.status !== 403 || error.response?.data?.code !== 'CSRF_REISSUED') throw error
    // Retry with the fresh csrf_token cookie the DAL just set.
    csrfToken = cookieUtility.get(`${import.meta.env.VITE_COOKIE_PREFIX}csrf_token`)
    return axios.post(
      `${AUTH_URL}/auth/logout`,
      {},
      {
        withCredentials: true,
        headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : {},
      },
    )
  }
}

class AuthService {
  /**
   * Authenticate against the DAL. On success the server sets auth cookies.
   *
   * @param {string} email
   * @param {string} password
   * @returns {Promise<import('axios').AxiosResponse>}
   */
  async login(email, password) {
    return loginUser(email, password)
  }

  /**
   * Invalidate the current session on the DAL.
   *
   * @returns {Promise<import('axios').AxiosResponse>}
   */
  async logout() {
    return logoutUser()
  }
}

export default new AuthService()
